module.exports = __webpack_public_path__ + "static/media/tenant1-1.b5491d80.png";